import {
  DefaultConfigBuilderContext,
  PresentationType,
  SectionViewBuilderContext,
  SectionWidget,
  ShouldFetchDataResolverContext,
} from "../section-widget";
import { BrandingSectionConfig } from "./branding-section-config";
import { BrandingSectionView } from "./branding-section-view";
import { v4 as uuidv4 } from "uuid";
import { BrandingSectionData } from "./branding-section-data";

type SectionType = "branding";

export class BrandingSectionWidget
  implements SectionWidget<SectionType, BrandingSectionConfig, BrandingSectionView>
{
  type: SectionType = "branding";

  supportedPresentationTypes: PresentationType[] = ["cma", "general-presentation"];

  buildDefaultConfig(_: DefaultConfigBuilderContext): BrandingSectionConfig {
    return {
      type: "branding",
      navTitle: "Contact Info",
      id: uuidv4(),
      shouldFetchFromUserProfile: false,
      visibility: true,
      agentName: undefined,
      agentEmail: undefined,
      agentTitle: undefined,
      agentPhoneNumber: undefined,
      agentAvatar: undefined,
      officeName: undefined,
      officeLogo: undefined,
      website: undefined,
      instagramUrl: undefined,
      facebookUrl: undefined,
      xUrl: undefined,
      youtubeUrl: undefined,
      linkedInUrl: undefined,
      showAgentName: true,
      showAgentTitle: true,
      showAgentEmail: true,
      showAgentPhoneNumber: true,
      showAgentAvatar: true,
      showOfficeName: true,
      showOfficeLogo: true,
      showWebsite: true,
      showInstagramUrl: true,
      showFacebookUrl: true,
      showXUrl: true,
      showYoutubeUrl: true,
      showLinkedInUrl: true,
    };
  }

  buildView({
    sectionConfig: config,
    sectionData: data,
  }: SectionViewBuilderContext<BrandingSectionConfig, BrandingSectionData>): BrandingSectionView {
    if (config.type !== "branding") throw new Error("Unexpected section type.");

    const { id, type, visibility } = config;

    const {
      agentName = data?.agentName || null,
      agentTitle = data?.agentTitle || null,
      agentEmail = data?.agentEmail || null,
      agentPhoneNumber = data?.agentPhoneNumber || null,
      agentAvatar = data?.agentAvatar || null,
      officeName = data?.officeName || null,
      officeLogo = data?.officeLogo || null,
      website = data?.website || null,
      instagramUrl = data?.instagramUrl || null,
      facebookUrl = data?.facebookUrl || null,
      xUrl = data?.xUrl || null,
      youtubeUrl = data?.youtubeUrl || null,
      linkedInUrl = data?.linkedInUrl || null,
      showAgentName = true,
      showAgentTitle = true,
      showAgentEmail = true,
      showAgentPhoneNumber = true,
      showAgentAvatar = true,
      showOfficeName = true,
      showOfficeLogo = true,
      showWebsite = true,
      showInstagramUrl = true,
      showFacebookUrl = true,
      showXUrl = true,
      showYoutubeUrl = true,
      showLinkedInUrl = true,
    } = config;

    const view: BrandingSectionView = {
      id,
      type,
      navTitle: config.navTitle || "Contact Info",
      agentName,
      agentTitle,
      agentEmail,
      agentPhoneNumber,
      agentAvatar,
      officeName,
      officeLogo,
      website,
      instagramUrl,
      facebookUrl,
      xUrl,
      youtubeUrl,
      linkedInUrl,
      visibility,
      preferences: {
        showAgentName,
        showAgentTitle,
        showAgentEmail,
        showAgentPhoneNumber,
        showAgentAvatar,
        showOfficeName,
        showOfficeLogo,
        showWebsite,
        showInstagramUrl,
        showFacebookUrl,
        showXUrl,
        showYoutubeUrl,
        showLinkedInUrl,
      },
    };

    return view;
  }

  shouldInvalidateData(
    _: ShouldFetchDataResolverContext<BrandingSectionConfig, BrandingSectionData>
  ): boolean {
    return false;
  }

  canFetchData({ config }: { config: BrandingSectionConfig }) {
    return Boolean(config.shouldFetchFromUserProfile);
  }
}
